module.exports = __webpack_public_path__ + "img/logo.d74be416.png";